













import { Component, Prop, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';

@Component({
    components: { vSelect }
})
export default class Select extends Vue {
    @Prop(String) readonly placeholder: string | undefined;
    @Prop() readonly value: string | string[] | undefined;
    @Prop(Array) readonly options: string[] | undefined;
    @Prop(String) readonly label?: string | undefined;
    @Prop(Function) readonly handleInput?: (val: any) => void | undefined;
    @Prop(Boolean) readonly searchable?: boolean | undefined;
    @Prop(Boolean) readonly clearable?: boolean | undefined;
    @Prop(Boolean) readonly multiple?: boolean | undefined;
}
